import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { PopulateRamcoUserInformationRequest } from 'resources/server/UserProfileServer';
import UserProfileServer from 'resources/server/UserProfileServer';

import { userSettingsKey } from '../queries/useGetUserSettingsQuery';

const usePopulateRamcoUserInformationMutation = (): UseMutationResult<
  string | undefined,
  AxiosError,
  PopulateRamcoUserInformationRequest,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UserProfileServer.PopulateRamcoUserInformation.bind(UserProfileServer),
    onSuccess: async () => {
      await queryClient.invalidateQueries([userSettingsKey]);
    },
  });
};

export default usePopulateRamcoUserInformationMutation;
